const FleetTransportation = () => {
    return (
    <div>
      <div className="">
        <img src="/logisticsBanner/banner-2.jpg" width="100%"/>
      </div>
      <div className="flex flex-col justify-center items-center mb-[1.5rem]">
        <hr className="w-[52rem]"/>
          <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5 ">
          
            <div className="flex flex-col justify-center">
              <h1 className="font-bold text-3xl text-[#373737]">
                Fleet & Transportation
              </h1>
              <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              TCS is currently maintaining a fleet of over 850 vehicles, covering approximately
              1.5 million kilometres per month, with a workforce of 432 drivers and 66 workshop staff.
              National Energy Conservation Centre (ENERCON), Govt. of Pakistan declared TCS Logistics
              as the ‘Best Fleet Management Company of Pakistan’. TCS Logistics is the 3rd largest 
              satellite-tracked, fleet management company in Pakistan. We are maintaining an outstanding
              safety record and following safety procedures. We know what it takes to master the roads
              and the machines. TCS has been constantly improving its expertise in fleet management
              for the corporate sector of the country.
              </p>
              <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              A dedicated fleet of chartered aircraft and a Boeing 737 carries cargo to the four
              corners of the country, liberating valued TCS customers from the constraints of
              commercial airline schedules. This invaluable flexibility in scheduling flights
              gives TCS an unbeatable competitive advantage in both its domestic and international operations.
              </p>
              <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              The main hubs are Karachi, Lahore and Islamabad. Dubai serves as the marshalling point for international
              traffic. TCS is the only Express & Logistics Company in Pakistan that has its own dedicated fleet of charted
              cargo aircraft. TCS has one of the biggest company owned fleet in Pakistan 4,500+ Vehicles and company owned 
              workshops in geographical spreads of the country
              </p>
            </div>
            <div className="flex-1 flex flex-col justify-center items-center">
              <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
            </div>
          </div>
      
      </div>
    </div>

    )
};
export default FleetTransportation;